import { atom } from 'jotai'

export interface AccordionState {
  [id: string]: boolean
}

export const accordionStateAtom = atom<AccordionState>({})
